// extracted by mini-css-extract-plugin
export default {"main":"MBttn_main__BqCxD","bttn":"MBttn_bttn__dfzh+","icon":"MBttn_icon__P7Duk","title":"MBttn_title__NG-C0","bttnWrap":"MBttn_bttnWrap__2Eahs","link":"MBttn_link__9Yf19"};